import type { IProfileService } from "App/Modules/Auth";

import type { IProfile } from "App/Modules/Models";

import { noop } from "angular";
import type { IModalService } from "App/Modules/Services";

export default class ProfilePasswordComponentController {
    public static $inject = ["mmProfileService", "mmModalService"];

    public profile: IProfile;

    constructor(private profileService: IProfileService, private readonly modalService: IModalService) {}

    public editPassword() {
        this.modalService.open<IProfile, null>("mmPasswordEdit", this.profile).subscribe(noop, () => noop);
    }
}
